import Link from "next/link";
import ArrowIcon from "@/components/icons/arrow";
import { Button } from "@/components/ui/button";
import ExtendedImage from "@/components/ui/extended-image";

export interface AcademySearchResult {
  id: string;
  title: string;
  slug: string;
  summary: string;
  mobileImageUrl: string;
  webImageUrl: string;
  coverImageUrl: string;
  primaryActionText: string;
  primaryActionUrl: string;
}

interface SearchAcademyCardProps {
  item: AcademySearchResult;
}

const SearchAcademyCard = ({ item }: SearchAcademyCardProps) => {
  const href = item.slug.startsWith("/") ? item.slug : `/${item.slug}`;
  const imageUrl = item.coverImageUrl || item.webImageUrl || item.mobileImageUrl;

  return (
    <div className="border border-slate-200 rounded-2xl h-50 flex flex-row justify-end w-full p-4 relative overflow-hidden group">
      <ExtendedImage
        alt={`${item.title} image`}
        className="absolute inset-0 h-full w-full object-cover"
        fill={true}
        src={imageUrl}
      />
      <div className="max-w-48 h-full justify-end items-start z-10 flex flex-col gap-2 relative">
        <h2 className="text-lg leading-5.5 font-bold text-neutral-900 drop-shadow-xs">
          {item.title}
        </h2>
        <p className="text-xs leading-4.5 font-medium line-clamp-3 text-neutral-700">
          {item.summary}
        </p>
        <Link href={href}>
          <Button type="button">
            {item.primaryActionText} <ArrowIcon className="stroke-white" />
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default SearchAcademyCard;
